<template>
  <div class="hello" id="mainContainer">
		<!-- copy these lines to your document: -->

	<div id="aosiwebsitev11_hype_container" class="HYPE_document" style="margin:auto;position:relative;width:100%;height:6122px;overflow:hidden;">
		<!-- <script type="text/javascript" charset="utf-8" src="Aosi_website_v1.1.1.hyperesources/aosiwebsitev11_hype_generated_script.js?12349"></script> -->
	</div>

	<!-- end copy -->
	


	<!-- text content for search engines: -->

	<div style="display:none" aria-hidden=true>

		<div>环境可持续性：
</div>
		<div>● 工业气泵</div>
		<div>安全性能：
</div>
		<div>更专注于减少废料、废水、化工产品使用，运输等来降低碳排放，与一次性桶相比可减少高达80%的废料，与不锈钢桶相比可减少高达97%的废水，同类产品中单次灌装碳足迹最低。
</div>
		<div>桶具有超过20bar的承压能力，安全阀提供双重保障，无任何爆桶风险，同类产品中最强最安全的啤酒桶。
</div>
		<div>具有高端酒吧氛围的竹木柜台提升了智能系统的外观档次。竹子的强度和抗刮性能确保了其耐用性，并保持了原始外观。</div>
		<div>产品系列：
</div>
		<div>确保耐用性、耐腐蚀性和易于维护性，符合卫生标准并延长设备的使用寿命。</div>
		<div>高端优质啤酒桶提供多种规格，包括30升、20升、18升、15升、10升、5升、3升等，以满足行业内不同的需求。
</div>
		<div>● 竹木柜台</div>
		<div>● 不锈钢部件</div>
		<div>创新：
</div>
		<div>系列高端优质啤酒桶包含多种技术创新，如塑钢 (GFRP) 结构，多重阻隔技术，风味稳定技术，双层桶和双层袋解决方案，电子标签追踪系统等，以确保同类产品中最优的性能，最佳的安全性能和品质。系列优质特征共同将Gprokeg定位于饮料行业的桶装领先解决方案，提供同类产品中无与伦比的超长保质期、风味保持、安全防爆、超高性价比及最佳的环境可持续性。
</div>
		<div>打酒前智能系统自动检测袋子或杯子放置情况，防止出酒错误或溢出。</div>
		<div>Ai.Pro.OS - 企业软件平台概览
</div>
		<div>● 杯袋检测</div>
		<div>Ai.Pro.OS旨在管理Progema、AiCerv和GProkeg系列机器和啤酒桶的首要智能平台解决方案。利用智能零售AIoT平台，为啤酒公司提供先进的功能和服务。
</div>
		<div>云服务
</div>
		<div>终端客户可定制特定风味的啤酒，智能系统可现场配制以满足不同的喜好，增强客户体验。</div>
		<div>24小时访问您的管理仪表板，以便您可以在世界任何地方检查您的ARM单位。
</div>
		<div>● 水果风味(可选)</div>
		<div>中文
</div>
		<div>社交媒体
</div>
		<div></div>
		<div>面向客户的营销活动、促销和优惠券都是通过我们的平台完成的。
</div>
		<div>● 在线管理平台：一个集中管理机器和啤酒桶的平台，简化运营流程，增强用户体验。
● 交互软件：促进用户和机群的无缝交互，增强用户的参与度。
● 支付方式整合：支持支付宝和微信等多种支付方式，确保交易顺利安全进行。
● 移动应用程序：对啤酒厂、运营商和最终用户进行即时管理。用户通过手机App购买啤酒。
● 云计算服务：提供对机器、应用程序和数据的远程访问，具有灵活性和可扩展性。
● 数据安全和隐私：通过安全稳定的云计算服务确保数据安全，保护隐私信息。
</div>
		<div>完全集成
</div>
		<div>● 实时状态监控：在手机和电脑上实时查看啤酒机运营状态信息。
● 机器管理：监控机器和组件的位置、状态、库存量、运行状况和性能。接收错误通知并执行远
   程更新。
● 产品管理：自定义不同啤酒和容量、更改价格和管理产品信息。
● 补货：实时接收补货信息，由移动应用程序同步数据，利用RFID技术精确管理啤酒库存。
● 广告推选：制定和管理广告内容、数码标识、促销方式、广告活动、社交媒体整合以及优惠券
   发放。
● 权限管理：可自定义角色和权限，实现灵活安全运营。
● 独立的财务系统：为酿酒厂、场地所有者和设备操作人员等用户提供灵活的财务系統，包括定
   制费用和佣金。
● 会员系统：实施会员计划、促销活动、优惠券，并管理积分兑换，以增强B2C解决方案。
● 数据收集：获取客户联系信息、喜好和资料。
● 互动方式：通过与品牌相关的投票、调研/调查和促销活动吸引顾容。
● 品牌效应：拓展品牌效应，与潜在客户建立联系，扩大营销数据。在同一平台上同时管理B2B
   和B2C。
● 定向优惠：根据客户对啤酒风格、产品和本地活动的偏好，推送个性化优惠。
</div>
		<div>所有第三方硬件和软件都是完全集成的，因此您不必担心处理多个平台。
</div>
		<div>内容
</div>
		<div>EcoReKeg
</div>
		<div>内置显示器（10-50英寸）可以展示促销到定价或任何您想要的东西，可随时通过无线方式更新。
</div>
		<div>主要功能和服务：
</div>
		<div>联系我们
</div>
		<div>支持
</div>
		<div>实时更新
</div>
		<div>关健功能：
</div>
		<div>香港上环文咸街50号17楼，邮编999077
湖南省岳阳市岳阳城陵矶综合保税区二期标准化厂房2号楼3楼

北京市昌平区北七家镇宏福10号院1号楼3050-4室

电话：+86 152 0730 2790  |  微信号：AiCerv  |  WhatsApp: AiCerv
</div>
		<div>利用Gprokeg的先进技术，智能系统的同一打酒头可提供四种不同类型的新鲜啤酒，为客户提供多样化选择。</div>
		<div>有时候事情会出错，我们致力于尽快解决问题。
</div>
		<div>内置多种传感器和高级安全功能，您可以选择接收几乎任何活动的实时更新。
</div>
		<div>奥思智能科技
</div>
		<div>● 2个20升桶</div>
		<div>总结：
</div>
		<div>限制未授权人员的访问，防止篡改或未经授权的使用，增强系统的安全性。</div>
		<div>全套冷链技术
</div>
		<div>● 电子锁</div>
		<div>● 4个20升桶</div>
		<div>AiCerv - IBE 2
</div>
		<div>Ai.Pro.OS交互式售货平台提供了一个全面的解决方案，以提高运营效率、有效吸引客户并推动业务增长。通过我们创新的平台，拥抱售货业务的未来，将您的售货业务提升到新的高度。

</div>
		<div>奥思智能科技有限公司总部位于美国硅谷，分别在巴西、以色列和中国设有办事处，为精酿啤酒行业推出了突破性的系统。自2003年以来，帮助零售商在更多地方接触客户。我们的首要产品Ai.Cerv是一款在中国制造的先进啤酒机服务系统。它包含顶级硬件、软件和优质桶。它通过移动应用程序和云平台轻松控制，为啤酒厂卓越服务建立了新标准，同时降低了运营成本。我们专注于自动化零售机器（ARM）和智能冷却器技术。通过提供最好的通用自动化零售解决方案，我们很高兴与包括英特尔、SAP和埃森哲在内的技术领导者合作。</div>
		<div>降低成本
</div>
		<div>每次打酒后自动吹扫减少啤酒浪费，同时自动清洗管路及智能打酒系统，确保卫生，并防止不同种类啤酒之间的交叉污染和串味，确保每杯啤酒跟啤酒厂发酵罐出来时的啤酒风味品质基本一致。</div>
		<div>降低啤酒浪费
</div>
		<div>● 自动清洁循环</div>
		<div>精酿行业
全新的经济和生态系统解决方案
</div>
		<div>零二氧化碳
</div>
		<div>智能系统将打酒头温度控制在恒定的低温状态，以维持啤酒的最佳饮用温度，确保以最适宜的啤酒温度获得最佳的品尝体验。</div>
		<div>E-Mail: info@aosi.ai

</div>
		<div>与我们合作的公司
</div>
		<div>● 智能打酒头恒温控制</div>
		<div>全维度数据采集
</div>
		<div>AiCerv - IBC 4
</div>
		<div>客户可个性化地选择每杯啤酒的不同泡沫含量，智能系统可根据不同啤酒种类自动调整控制每杯啤酒的泡沫程度，确保始终如一的服务质量。</div>
		<div>● 泡沫控制</div>
		<div>EN</div>
		<div>智能系统能实现对设备远程监控和管理，以便运营商实时追踪溯源、解决问题和收集有价值的数据进行分析。</div>
		<div>● IoT, Wi-Fi和4G连接</div>
		<div>具有灵活性和稳定性，可轻松移动和安全放置机器。</div>
		<div>Copyright © 2025 Aosi | All Right Reserved
</div>
		<div>桶能为内装的啤酒提供长达12个月的保质期，包括开桶后4个月的保质期，因独特的多重阻隔技术及双层阻隔袋系统能提供对氧和二氧化碳超高的阳隔性能。
</div>
		<div>● 带锁万向轮</div>
		<div>超长的啤酒保质期：
</div>
		<div>超高性价比：
</div>
		<div>无需使用二氧化碳打酒，智能系统内的气泵能为啤酒桶提供打酒所需的压力介质，经济实惠且低碳环保。</div>
		<div>最佳的风味保持：
</div>
		<div>单次灌装成本比一次性桶可节省高达60％，桶可重复使用且兼容现有的标准金属分配器及灌装线，无需清洗、干燥、杀菌和空气置换，另外，可用压缩空气代替二氧化碳打酒，以节省运营成本。
</div>
		<div>通过防止包装材料中的物质迁移，杜绝清洗过程可能带来的化学残留，杜绝打酒过程中压力介质可能带来的对啤酒的污染，以及辐照及空气置换等来彻底消除酒茅内袋中可能的微生物和氧残留等技术，来确保内装啤酒的风味稳定性。
</div>
		<div>Cost-effectiveness:
</div>
		<div>● Four Barrels of 20 Liters Each</div>
		<div>● Beer Tower Refrigerated by Glycol
</div>
		<div>Delivers the necessary pressure for beer dispensing without CO2, offering a cost-effective and environmentally friendly solution.</div>
		<div>Prevents dispensing errors and spills by verifying the presence of cups or bags before beer dispensing.</div>
		<div>Allows customers to personalize their beer experience by selecting their preferred foam level, ensuring consistent serving quality through automatic foam control.</div>
		<div>Reduce costs
</div>
		<div>Ai.Pro.OS is an intelligent platform for managing a range of automatic beer dispensers and kegs. It offers advanced services through an AloT cloud platform, enhancing brewery operations.
</div>
		<div>Social Media
</div>
		<div>Key Features:
</div>
		<div>Environmental Sustainability:
</div>
		<div>Content
</div>
		<div>● Foam Control</div>
		<div>A full set of cold chain technology
</div>
		<div>Strand 50, 17th floor, 50 Bonham Strand, Sheung Wan, Hong Kong 999077
3rd Floor, Building 2, Standardized Factory Building, Phase II, Yueyang Chenglingji Comprehensive Bonded Zone, Yueyang City, Hunan Province

Hongfu International Innovation Center, 10 Haoyuan Beiqing Road, Changping District, Beijing

Tel:: +86 152 0730 2790  |  WeChat: AiCerv  |  WhatsApp: AiCerv
</div>
		<div>Zero carbon dioxide
</div>
		<div>Enhances security by limiting access to authorized personnel, safeguarding against tampering or unauthorized use.</div>
		<div>● Cups and Bags Detection</div>
		<div>● Centralized Management Portal: Streamlines machine and keg operations.
● Interactive Machine Software: Boosts user engagement.
● Diverse Payment Integration: Includes various payment modules for secure transactions.
● Mobile App: Facilitates remote management and beer purchases.
● Cloud Services: Offers remote access and scalability.
● Data Security: Prioritizes the protection of critical information.
</div>
		<div>Companies we work with
</div>
		<div>Core Functionalities:
</div>
		<div>The kegs focus on reducing material waste, water waste, chemicals, and transport to minimize carbon emissions. They produce about 80% less material waste compared to one-way kegs and 97% less water waste compared to stainless steel kegs, resulting in the lowest carbon footprint per fill.
</div>
		<div>● Electronic Lock</div>
		<div>Aosi Intelligent Technology
</div>
		<div>● Industrial Air Pump</div>
		<div>Ensures hygiene and prevents crosscontamination between beer styles by automatically cleaning after each serving, maintaining the quality of dispensed beer.</div>
		<div>Built in displays (10-50 inches) can present promos to pricing or anything you want. Updated over the air whenever you want.
</div>
		<div>Marketing campaigns, promotions, and coupons to your customers all done through our platform.
</div>
		<div>● Real-time Monitoring: Updates on machine operations via mobile and desktop.
● Machine Management: Tracks machine details and provides error alerts.
● Product Management: Manages beer varieties, pricing, and information.
● Restocking with RFID: Sends replenishment alerts and manages kegs accurately.
● Advertisement Management: Organizes digital content and promotions.
● Rights Management: Assigns roles for secure operations.
● Independent Financial System: Provides flexible financial systems for users such as breweries,
   venue owners, and equipment operators, including customized fees and commissions.
● Accounting & Membership Systems: Supports various stakeholders and B2C engagement.
● Data Collection & Engagement Tools: Gathers customer data and promotes interaction.
● Interactive Methods: Attract customers through brand-related polls, surveys, and promotional
   activities.
● Brand Messaging & Targeted Offers: Expands brand reach with personalized promotions.
● Targeted Offers: Deliver personalized promotions based on customers' preferences for beer
   styles, products, and local events.
</div>
		<div>Best Taste Preservation:
</div>
		<div>New ecosystem for Craft brewery
</div>
		<div>Real-Time Updates
</div>
		<div>The technology ensures taste and flavor stability by preventing packaging material migration, chemical residue from the cleaning process, and contamination from pressure mediums during beer dispensing. Radiation sterilization and air replacement solutions eliminate germs and oxygen from the inner bag and spear.
</div>
		<div>The kegs offer a shelf life of up to 12 months, including 4 months on tap, thanks to a unique multi-barrier technology and a double bag system that provides high barrier performance to oxygen and carbon dioxide.
</div>
		<div>Product Range:
</div>
		<div>Safety:
</div>
		<div>Reduce beer waste
</div>
		<div>Extremely Long Shelf Life:
</div>
		<div>Enhances customer experience by offering customizable flavor options, catering to varying preferences.
</div>
		<div>Enables remote monitoring and management of the system, empowering operators to track performance, address issues, and gather valuable analytics data.</div>
		<div>The kegs boast over 20-bar pressure resistance and include an overpressure valve for double safety assurance, reducing the risk of keg explosions. They are designed to be the most strong and safe kegs available.
</div>
		<div>With a multitude of sensors and advanced safety features built-in you can opt to receive real-time updates on virtually any activity.
</div>
		<div>Utilizing Gprokeg technology, the system canserve up to four types of beer from the same tap, providing customers with a diverse selection.</div>
		<div>Support
</div>
		<div>Ensures durability, corrosion resistance, and easy maintenance, adhering to sanitation standards and extending equipment lifespan.</div>
		<div>Summary: 
</div>
		<div>● Two Barrels of 20 Liters Each</div>
		<div>The premium kegs are available in various sizes, including 30L, 20L, 18L, 15L, 10L, 5L, and 3L, catering to different needs in the industry.
</div>
		<div>Aosi Intelligent Technology, headquartered in Silicon Valley, USA, with offices worldwide in Brazil, Israel, and China, proudly introduces a groundbreaking ecosystem for the craft beer industry. Helping retailers reach customers in more places since 2003. Our premier offering, the AiCerv, is an advanced robotic beer-serving system crafted in China. It encompasses top-tier hardware, software, and premium kegs. Controlled effortlessly by mobile app and cloud platform, it establishes a new standard for brewery service excellence, while simultaneously reducing operational costs. We specialize in automated retail machines (ARMs) and smart cooler technologies. By offering the best universal automated retail solutions, we have the pleasure of working with technology leaders including Intel, SAP, and Accenture.</div>
		<div>Innovation:
</div>
		<div>Fully Integrated
</div>
		<div>● IoT, Wi-Fi, and 4G Connectivity</div>
		<div>The solution offers up to 60% lower cost per fill compared to one-way kegs. It's reusable and compatible with existing standard metal couplers and filling lines, eliminating the need for cleaning, drying, sterilization, and air replacement. Additionally, it allows for compressed air instead of CO2 for beer dispensing, saving on operational costs.
</div>
		<div>● Fruit Flavoring (Optional)</div>
		<div>Sometimes things go wrong. We're dedicated to making things right as quickly as possible.
</div>
		<div>Elevates the system's aesthetic with a highend bar ambiance.
Bamboo's strength and scratch-resistant properties ensure durability and maintain a pristine appearance.
</div>
		<div>● Stainless Steel Components</div>
		<div>Ai.Pro.OS enhances operation efficiency and customer engagement, driving business growth in the intelligent beer and brewery industry.

</div>
		<div>Contact us
</div>
		<div>● Automatic Cleaning Cycle</div>
		<div>● Wood Bamboo Counter</div>
		<div>Maintains beer at optimal temperatures, ensuring it's served at the ideal temperature for maximum enjoyment.</div>
		<div>The kegs feature innovative technology such as FRP (Glass Fiber Reinforced Plastic) construction, single keg and single bag solutions, and RFID tags for traceability, ensuring performance, safety, and quality.
</div>
		<div>All 3rd party hardware and software are fully integrated so you don't have to worry about dealing with multiple platforms.
</div>
		<div>Provides mobility and stability, allowing easy movement or secure placement of the machine as required.</div>
		<div>Ai.Pro.OS - Intelligent Beer Platform
</div>
		<div>● Industrial Wheels with Locks</div>
		<div>Cloud Services
</div>
		<div>24 hour access to your administrative dashboard so you can check on your ARM units from anywhere in the world.
</div>
		<div>All-dimensional data collection
</div>

	</div>

	<!-- end text content: -->


  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  mounted() {
    // 动态加载 HYPE 脚本
    this.loadHypeScript();
	},
  methods: {
    loadHypeScript() {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      // 使用相对路径直接引用public目录下的文件
      script.src = '/Aosi_website_v1.1.1.hyperesources/aosiwebsitev11_hype_generated_script.js';
      
      script.onload = () => {
        console.log('HYPE script loaded successfully');
      };
      
      script.onerror = (error) => {
        console.error('Failed to load HYPE script:', error);
      };
      
      document.getElementById('aosiwebsitev11_hype_container').appendChild(script);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html {
    height:100%;
  }
  body {
    background-color:#FFF;
    margin:0;
    height:100%;
  }

</style>
